<dialog-draggable-header>Tool/Part Relationship</dialog-draggable-header>

<div *ngIf="hasLoaded" class="h-100">
  <data-table [data]="parts" [columns]="columns" (lazyLoad)="onLazyLoad($event)" [lazy]="true" (edit)="rowEdit($event)"
    [pageSize]="pageOptions.size" [paging]="true" [totalRecords]="totalParts" [defaultSortField]="'partNumber'"
    [loading]="loading" [filterColumnDisplay]="false">
    <ng-container actionStart>
      <span class="spacerLeft"> Parts associated to Tool #: {{tool.toolNo}}</span>
      <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
      <button mat-button *ngIf="!this.resourced; else hidePartsByProgram" (keypress)="showPartsByProgram()"
        (click)="showPartsByProgram()" style="max-width: 300px;overflow: hidden;text-overflow: ellipsis;"
        [title]="tool.programNameYear">
        Show Parts by Program: <b>{{tool.programNameYear}}</b>
      </button>
      <ng-template #hidePartsByProgram>
        <button mat-button [disabled]="true">
          Show Parts by Program: <b>{{tool.programNameYear}}</b>
        </button>
      </ng-template>
      <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
      <button mat-button *ngIf="!this.resourced; else hideShowAllParts" (keypress)="showAllParts()"
        (click)="showAllParts()">
        Show All Parts
      </button>
      <ng-template #hideShowAllParts>
        <button mat-button [disabled]="true">
          Show All Parts
        </button></ng-template>
      <mat-divider vertical class="action-bar-vertical-divider"></mat-divider>
      <mat-form-field class="spacerLeft">
        <input #searchBar id="search-part-id" type="text" matInput (keydown.enter)="searchPartToolRelation(searchBar)"
          [(ngModel)]="searchBarInput" placeholder="  Search Part Number" />
        <span *ngIf="searchBarInput" style="margin-left:-20px;">
          <a (click)="clearSearch()">
            <i class="fa fa-times" style="color: rgb(149, 149, 153); cursor: pointer;"></i>
          </a>
        </span>
        <button mat-icon-button matSuffix (click)="searchPartToolRelation(searchBar)"
          (keydown.enter)="searchPartToolRelation(searchBar)">
          <mat-icon matSuffix>search</mat-icon>
        </button>
      </mat-form-field>
    </ng-container>
    <ng-container actionEnd>
      <button mat-button (keypress.enter)="close()" (click)="close()">Close</button>
    </ng-container>
  </data-table>
</div>